import { combineReducers } from "redux";
import reportsReducer from "./reportsReducer";

const repsReducer = combineReducers({
    reports: reportsReducer
});

export default repsReducer;